module.exports = new __parcel__URL__("partner_5.d9ce2430.jpg").toString();